import { Tag, Typography } from "antd";
import { useT } from "../i18n/context";

const { Text } = Typography;

interface SessionExitedNoticeProps {
  reason?: string;
}

export default function SessionExitedNotice({ reason }: SessionExitedNoticeProps) {
  const t = useT();
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        padding: "12px 0",
      }}
    >
      <Tag
        color="default"
        style={{
          fontSize: 12,
          padding: "4px 12px",
          borderRadius: 999,
          background: "var(--lude-im-bg-secondary)",
          color: "var(--lude-im-text-secondary)",
          border: "1px solid var(--lude-im-border)",
        }}
      >
        ⏹ {t("chat.session_exited")}
        {reason && (
          <Text type="secondary" style={{ fontSize: 11, marginLeft: 8 }}>
            ({reason})
          </Text>
        )}
      </Tag>
    </div>
  );
}
